import findParentTree from 'helpers/filter/findParentTree'

function completeFiltersTree(filters, categories) {
	let completeFilters = []

	filters.forEach(filter => {
		completeFilters = completeFilters.concat(findParentTree(filter, categories))
		completeFilters.push(filter)
	})

	return completeFilters
}

export default completeFiltersTree
